export const routeManagerMenus = () => ({
    id: `main-menu-2-all`,
    path: '/management/route-management/regions',
    label: 'Route Management',
    isEnabled: true,
    svg: (
        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill="#ffffff" d="M10 2a2 2 0 0 0-2 2v4a2 2 0 1 0 4 0V4a2 2 0 0 0-2-2zm-1 4V4a1 1 0 0 1 2 0v2a1 1 0 0 1-2 0zm-2.586 9.414a2 2 0 0 1 2.828 0L10 18.172l1.758-1.758a2 2 0 0 1 2.828 0l5 5-1.414 1.414-5-5a1 1 0 0 0-1.414 0L10 19.586l-2.172-2.172a1 1 0 0 0-1.414 0l-5 5L.586 19.414l5-5zM19 11h2v2h-2v-2zm-7 0h2v2h-2v-2zm-4 0h2v2H8v-2z" />
        </svg>

    ),

    Description: 'Route management optimizes and streamlines the planning, tracking, and execution of routes, enabling businesses to enhance efficiency, reduce costs, and improve customer satisfaction.',
    subMenu: [
        {
            id: `main-menu-2-all`,
            path: '/management/route-management/regions',
            label: 'Service Layers',
            isEnabled: true,
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill="#ffffff" d="M10 2a2 2 0 0 0-2 2v4a2 2 0 1 0 4 0V4a2 2 0 0 0-2-2zm-1 4V4a1 1 0 0 1 2 0v2a1 1 0 0 1-2 0zm-2.586 9.414a2 2 0 0 1 2.828 0L10 18.172l1.758-1.758a2 2 0 0 1 2.828 0l5 5-1.414 1.414-5-5a1 1 0 0 0-1.414 0L10 19.586l-2.172-2.172a1 1 0 0 0-1.414 0l-5 5L.586 19.414l5-5zM19 11h2v2h-2v-2zm-7 0h2v2h-2v-2zm-4 0h2v2H8v-2z" />
                </svg>

            ),
            subMenu: [
                {
                    id: `coln-1-collections`,
                    label: 'Country',
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill="#007BFF" d="M12 2a10 10 0 1 0 10 10A10.011 10.011 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8.009 8.009 0 0 1-8 8zm4-10h-3V7a1 1 0 0 0-2 0v3H8a1 1 0 0 0 0 2h3v3a1 1 0 0 0 2 0v-3h3a1 1 0 0 0 0-2z" />
                        </svg>

                    ),
                    path: '/management/route-management/regions',
                    isEnabled: true,

                },
                {
                    id: `coln-1-collections`,
                    label: 'Region',
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill="#007BFF" d="M12 2a10 10 0 1 0 10 10A10.011 10.011 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8.009 8.009 0 0 1-8 8zm4-10h-3V7a1 1 0 0 0-2 0v3H8a1 1 0 0 0 0 2h3v3a1 1 0 0 0 2 0v-3h3a1 1 0 0 0 0-2z" />
                        </svg>

                    ),
                    path: '/management/route-management/regions',
                    isEnabled: true,

                },
                {
                    id: `coln-1-collections`,
                    label: 'Zone',
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill="#007BFF" d="M12 2a10 10 0 0 0-10 10 10 10 0 0 0 3.512 7.598l.494.452 1.728-1.796-.573-.524a8 8 0 1 1 11.678 0l-.573.524 1.728 1.796.494-.452A10 10 0 0 0 22 12a10 10 0 0 0-10-10zm0 4a6 6 0 0 0-6 6 6 6 0 0 0 6 6 6 6 0 0 0 6-6 6 6 0 0 0-6-6zm0 4a2 2 0 0 1 2 2 2 2 0 0 1-2 2 2 2 0 0 1-2-2 2 2 0 0 1 2-2z" />
                        </svg>

                    ),
                    path: '/management/route-management/zones',
                    isEnabled: true,

                },

                {
                    id: `coln-1-collections`,
                    label: 'Cluster',
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill="#007BFF" d="M12 2a10 10 0 0 0-10 10 10 10 0 0 0 3.512 7.598l.494.452 1.728-1.796-.573-.524a8 8 0 1 1 11.678 0l-.573.524 1.728 1.796.494-.452A10 10 0 0 0 22 12a10 10 0 0 0-10-10zm0 4a6 6 0 0 0-6 6 6 6 0 0 0 6 6 6 6 0 0 0 6-6 6 6 0 0 0-6-6zm0 4a2 2 0 0 1 2 2 2 2 0 0 1-2 2 2 2 0 0 1-2-2 2 2 0 0 1 2-2z" />
                        </svg>

                    ),
                    path: '/management/route-management/zones',
                    isEnabled: true,

                },
                {
                    id: `coln-1-collections`,
                    label: 'Branch',
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill="#007BFF" d="M12 2a10 10 0 0 0-10 10 10 10 0 0 0 3.512 7.598l.494.452 1.728-1.796-.573-.524a8 8 0 1 1 11.678 0l-.573.524 1.728 1.796.494-.452A10 10 0 0 0 22 12a10 10 0 0 0-10-10zm0 4a6 6 0 0 0-6 6 6 6 0 0 0 6 6 6 6 0 0 0 6-6 6 6 0 0 0-6-6zm0 4a2 2 0 0 1 2 2 2 2 0 0 1-2 2 2 2 0 0 1-2-2 2 2 0 0 1 2-2z" />
                        </svg>

                    ),
                    path: '/management/route-management/zones',
                    isEnabled: true,

                },

                {
                    id: `coln-1-collections`,
                    label: 'Routes',
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill="#007BFF" d="M10.707 7.293a1 1 0 0 0-1.414 0L5 11.586V10a1 1 0 1 0-2 0v4a1 1 0 0 0 1 1h4a1 1 0 1 0 0-2H6.414l4.293-4.293a1 1 0 0 0 0-1.414zM18 3h-4a1 1 0 1 0 0 2h1.586l-4.293 4.293a1 1 0 0 0 1.414 1.414L17 6.414V8a1 1 0 1 0 2 0V4a1 1 0 0 0-1-1zm2 14h-4a1 1 0 1 0 0 2h1.586l-4.293 4.293a1 1 0 0 0 1.414 1.414L17 19.414V21a1 1 0 1 0 2 0v-4a1 1 0 0 0-1-1z" />
                        </svg>

                    ),
                    path: '/management/route-management/routes',
                    isEnabled: true,

                },
                {
                    id: `coln-1-collections`,
                    label: 'Circle',
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill="#007BFF" d="M12 2a10 10 0 0 0-10 10 10 10 0 0 0 3.512 7.598l.494.452 1.728-1.796-.573-.524a8 8 0 1 1 11.678 0l-.573.524 1.728 1.796.494-.452A10 10 0 0 0 22 12a10 10 0 0 0-10-10zm0 4a6 6 0 0 0-6 6 6 6 0 0 0 6 6 6 6 0 0 0 6-6 6 6 0 0 0-6-6zm0 4a2 2 0 0 1 2 2 2 2 0 0 1-2 2 2 2 0 0 1-2-2 2 2 0 0 1 2-2z" />
                        </svg>

                    ),
                    path: '/management/route-management/zones',
                    isEnabled: true,

                },
                {
                    id: `coln-1-collections`,
                    label: 'Switch',
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill="#007BFF" d="M12 2C7.59 2 4 5.59 4 10c0 6.49 8 12 8 12s8-5.51 8-12c0-4.41-3.59-8-8-8zm0 16c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm-2-6H8c0-2.21 1.79-4 4-4V6c-3.31 0-6 2.69-6 6h2c0-2.21 1.79-4 4-4v2c-2.21 0-4 1.79-4 4h2c0-2.21 1.79-4 4-4v2c-2.21 0-4 1.79-4 4z" />
                        </svg>

                    ),
                    path: '/management/route-management/route-points',
                    isEnabled: true,

                },
                {
                    id: `coln-1-collections`,
                    label: 'Beats',
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill="#007BFF" d="M12 2C7.59 2 4 5.59 4 10c0 6.49 8 12 8 12s8-5.51 8-12c0-4.41-3.59-8-8-8zm0 16c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm-2-6H8c0-2.21 1.79-4 4-4V6c-3.31 0-6 2.69-6 6h2c0-2.21 1.79-4 4-4v2c-2.21 0-4 1.79-4 4h2c0-2.21 1.79-4 4-4v2c-2.21 0-4 1.79-4 4z" />
                        </svg>

                    ),
                    path: '/management/route-management/route-points',
                    isEnabled: true,

                },
                {
                    id: `coln-1-collections`,
                    label: 'BPL',
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill="#007BFF" d="M12 2C7.59 2 4 5.59 4 10c0 6.49 8 12 8 12s8-5.51 8-12c0-4.41-3.59-8-8-8zm0 16c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm-2-6H8c0-2.21 1.79-4 4-4V6c-3.31 0-6 2.69-6 6h2c0-2.21 1.79-4 4-4v2c-2.21 0-4 1.79-4 4h2c0-2.21 1.79-4 4-4v2c-2.21 0-4 1.79-4 4z" />
                        </svg>

                    ),
                    path: '/management/route-management/route-points',
                    isEnabled: true,

                },
                {
                    id: `coln-1-collections`,
                    label: 'Pincode',
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill="#007BFF" d="M12 2C7.59 2 4 5.59 4 10c0 6.49 8 12 8 12s8-5.51 8-12c0-4.41-3.59-8-8-8zm0 16c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm-2-6H8c0-2.21 1.79-4 4-4V6c-3.31 0-6 2.69-6 6h2c0-2.21 1.79-4 4-4v2c-2.21 0-4 1.79-4 4h2c0-2.21 1.79-4 4-4v2c-2.21 0-4 1.79-4 4z" />
                        </svg>

                    ),
                    path: '/management/route-management/route-points',
                    isEnabled: true,

                },
                {
                    id: `coln-1-collections`,
                    label: 'STD code',
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill="#007BFF" d="M12 2C7.59 2 4 5.59 4 10c0 6.49 8 12 8 12s8-5.51 8-12c0-4.41-3.59-8-8-8zm0 16c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm-2-6H8c0-2.21 1.79-4 4-4V6c-3.31 0-6 2.69-6 6h2c0-2.21 1.79-4 4-4v2c-2.21 0-4 1.79-4 4h2c0-2.21 1.79-4 4-4v2c-2.21 0-4 1.79-4 4z" />
                        </svg>

                    ),
                    path: '/management/route-management/route-points',
                    isEnabled: true,

                },
                {
                    id: `coln-1-collections`,
                    label: 'Industry Code',
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill="#007BFF" d="M12 2C7.59 2 4 5.59 4 10c0 6.49 8 12 8 12s8-5.51 8-12c0-4.41-3.59-8-8-8zm0 16c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm-2-6H8c0-2.21 1.79-4 4-4V6c-3.31 0-6 2.69-6 6h2c0-2.21 1.79-4 4-4v2c-2.21 0-4 1.79-4 4h2c0-2.21 1.79-4 4-4v2c-2.21 0-4 1.79-4 4z" />
                        </svg>

                    ),
                    path: '/management/route-management/route-points',
                    isEnabled: true,

                },
                {
                    id: `coln-1-collections`,
                    label: 'NIC Code',
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill="#007BFF" d="M12 2C7.59 2 4 5.59 4 10c0 6.49 8 12 8 12s8-5.51 8-12c0-4.41-3.59-8-8-8zm0 16c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm-2-6H8c0-2.21 1.79-4 4-4V6c-3.31 0-6 2.69-6 6h2c0-2.21 1.79-4 4-4v2c-2.21 0-4 1.79-4 4h2c0-2.21 1.79-4 4-4v2c-2.21 0-4 1.79-4 4z" />
                        </svg>

                    ),
                    path: '/management/route-management/route-points',
                    isEnabled: true,

                },

            ],
        },
        {
            id: `main-menu-2-all`,
            path: '/management/route-management/regions',
            label: 'Service Types ',
            isEnabled: true,
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill="#ffffff" d="M10 2a2 2 0 0 0-2 2v4a2 2 0 1 0 4 0V4a2 2 0 0 0-2-2zm-1 4V4a1 1 0 0 1 2 0v2a1 1 0 0 1-2 0zm-2.586 9.414a2 2 0 0 1 2.828 0L10 18.172l1.758-1.758a2 2 0 0 1 2.828 0l5 5-1.414 1.414-5-5a1 1 0 0 0-1.414 0L10 19.586l-2.172-2.172a1 1 0 0 0-1.414 0l-5 5L.586 19.414l5-5zM19 11h2v2h-2v-2zm-7 0h2v2h-2v-2zm-4 0h2v2H8v-2z" />
                </svg>

            ),

        },
        {
            id: `main-menu-2-all`,
            path: '/management/route-management/regions',
            label: 'Routing Models',
            isEnabled: true,
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill="#ffffff" d="M10 2a2 2 0 0 0-2 2v4a2 2 0 1 0 4 0V4a2 2 0 0 0-2-2zm-1 4V4a1 1 0 0 1 2 0v2a1 1 0 0 1-2 0zm-2.586 9.414a2 2 0 0 1 2.828 0L10 18.172l1.758-1.758a2 2 0 0 1 2.828 0l5 5-1.414 1.414-5-5a1 1 0 0 0-1.414 0L10 19.586l-2.172-2.172a1 1 0 0 0-1.414 0l-5 5L.586 19.414l5-5zM19 11h2v2h-2v-2zm-7 0h2v2h-2v-2zm-4 0h2v2H8v-2z" />
                </svg>

            ),
            subMenu: [
                {
                    id: `coln-1-collections`,
                    label: 'P2P',
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill="#007BFF" d="M12 2a10 10 0 1 0 10 10A10.011 10.011 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8.009 8.009 0 0 1-8 8zm4-10h-3V7a1 1 0 0 0-2 0v3H8a1 1 0 0 0 0 2h3v3a1 1 0 0 0 2 0v-3h3a1 1 0 0 0 0-2z" />
                        </svg>

                    ),
                    path: '/management/route-management/regions',
                    isEnabled: true,

                },
                {
                    id: `coln-1-collections`,
                    label: 'P2H2P',
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill="#007BFF" d="M12 2a10 10 0 0 0-10 10 10 10 0 0 0 3.512 7.598l.494.452 1.728-1.796-.573-.524a8 8 0 1 1 11.678 0l-.573.524 1.728 1.796.494-.452A10 10 0 0 0 22 12a10 10 0 0 0-10-10zm0 4a6 6 0 0 0-6 6 6 6 0 0 0 6 6 6 6 0 0 0 6-6 6 6 0 0 0-6-6zm0 4a2 2 0 0 1 2 2 2 2 0 0 1-2 2 2 2 0 0 1-2-2 2 2 0 0 1 2-2z" />
                        </svg>

                    ),
                    path: '/management/route-management/zones',
                    isEnabled: true,

                },
                {
                    id: `coln-1-collections`,
                    label: 'H2H',
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill="#007BFF" d="M12 2a10 10 0 0 0-10 10 10 10 0 0 0 3.512 7.598l.494.452 1.728-1.796-.573-.524a8 8 0 1 1 11.678 0l-.573.524 1.728 1.796.494-.452A10 10 0 0 0 22 12a10 10 0 0 0-10-10zm0 4a6 6 0 0 0-6 6 6 6 0 0 0 6 6 6 6 0 0 0 6-6 6 6 0 0 0-6-6zm0 4a2 2 0 0 1 2 2 2 2 0 0 1-2 2 2 2 0 0 1-2-2 2 2 0 0 1 2-2z" />
                        </svg>

                    ),
                    path: '/management/route-management/zones',
                    isEnabled: true,

                },
                {
                    id: `coln-1-collections`,
                    label: 'P2C2H',
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill="#007BFF" d="M12 2a10 10 0 0 0-10 10 10 10 0 0 0 3.512 7.598l.494.452 1.728-1.796-.573-.524a8 8 0 1 1 11.678 0l-.573.524 1.728 1.796.494-.452A10 10 0 0 0 22 12a10 10 0 0 0-10-10zm0 4a6 6 0 0 0-6 6 6 6 0 0 0 6 6 6 6 0 0 0 6-6 6 6 0 0 0-6-6zm0 4a2 2 0 0 1 2 2 2 2 0 0 1-2 2 2 2 0 0 1-2-2 2 2 0 0 1 2-2z" />
                        </svg>

                    ),
                    path: '/management/route-management/zones',
                    isEnabled: true,

                },
                {
                    id: `coln-1-collections`,
                    label: 'M2C2P',
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill="#007BFF" d="M12 2a10 10 0 0 0-10 10 10 10 0 0 0 3.512 7.598l.494.452 1.728-1.796-.573-.524a8 8 0 1 1 11.678 0l-.573.524 1.728 1.796.494-.452A10 10 0 0 0 22 12a10 10 0 0 0-10-10zm0 4a6 6 0 0 0-6 6 6 6 0 0 0 6 6 6 6 0 0 0 6-6 6 6 0 0 0-6-6zm0 4a2 2 0 0 1 2 2 2 2 0 0 1-2 2 2 2 0 0 1-2-2 2 2 0 0 1 2-2z" />
                        </svg>

                    ),
                    path: '/management/route-management/zones',
                    isEnabled: true,

                },

                {
                    id: `coln-1-collections`,
                    label: 'M2H',
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill="#007BFF" d="M10.707 7.293a1 1 0 0 0-1.414 0L5 11.586V10a1 1 0 1 0-2 0v4a1 1 0 0 0 1 1h4a1 1 0 1 0 0-2H6.414l4.293-4.293a1 1 0 0 0 0-1.414zM18 3h-4a1 1 0 1 0 0 2h1.586l-4.293 4.293a1 1 0 0 0 1.414 1.414L17 6.414V8a1 1 0 1 0 2 0V4a1 1 0 0 0-1-1zm2 14h-4a1 1 0 1 0 0 2h1.586l-4.293 4.293a1 1 0 0 0 1.414 1.414L17 19.414V21a1 1 0 1 0 2 0v-4a1 1 0 0 0-1-1z" />
                        </svg>

                    ),
                    path: '/management/route-management/routes',
                    isEnabled: true,

                },
                {
                    id: `coln-1-collections`,
                    label: 'LineHaul',
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill="#007BFF" d="M10.707 7.293a1 1 0 0 0-1.414 0L5 11.586V10a1 1 0 1 0-2 0v4a1 1 0 0 0 1 1h4a1 1 0 1 0 0-2H6.414l4.293-4.293a1 1 0 0 0 0-1.414zM18 3h-4a1 1 0 1 0 0 2h1.586l-4.293 4.293a1 1 0 0 0 1.414 1.414L17 6.414V8a1 1 0 1 0 2 0V4a1 1 0 0 0-1-1zm2 14h-4a1 1 0 1 0 0 2h1.586l-4.293 4.293a1 1 0 0 0 1.414 1.414L17 19.414V21a1 1 0 1 0 2 0v-4a1 1 0 0 0-1-1z" />
                        </svg>

                    ),
                    path: '/management/route-management/routes',
                    isEnabled: true,

                },
                {
                    id: `coln-1-collections`,
                    label: 'Milk Run',
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill="#007BFF" d="M10.707 7.293a1 1 0 0 0-1.414 0L5 11.586V10a1 1 0 1 0-2 0v4a1 1 0 0 0 1 1h4a1 1 0 1 0 0-2H6.414l4.293-4.293a1 1 0 0 0 0-1.414zM18 3h-4a1 1 0 1 0 0 2h1.586l-4.293 4.293a1 1 0 0 0 1.414 1.414L17 6.414V8a1 1 0 1 0 2 0V4a1 1 0 0 0-1-1zm2 14h-4a1 1 0 1 0 0 2h1.586l-4.293 4.293a1 1 0 0 0 1.414 1.414L17 19.414V21a1 1 0 1 0 2 0v-4a1 1 0 0 0-1-1z" />
                        </svg>

                    ),
                    path: '/management/route-management/routes',
                    isEnabled: true,

                },
                {
                    id: `coln-1-collections`,
                    label: 'H2M',
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill="#007BFF" d="M10.707 7.293a1 1 0 0 0-1.414 0L5 11.586V10a1 1 0 1 0-2 0v4a1 1 0 0 0 1 1h4a1 1 0 1 0 0-2H6.414l4.293-4.293a1 1 0 0 0 0-1.414zM18 3h-4a1 1 0 1 0 0 2h1.586l-4.293 4.293a1 1 0 0 0 1.414 1.414L17 6.414V8a1 1 0 1 0 2 0V4a1 1 0 0 0-1-1zm2 14h-4a1 1 0 1 0 0 2h1.586l-4.293 4.293a1 1 0 0 0 1.414 1.414L17 19.414V21a1 1 0 1 0 2 0v-4a1 1 0 0 0-1-1z" />
                        </svg>

                    ),
                    path: '/management/route-management/routes',
                    isEnabled: true,

                },
                {
                    id: `coln-1-collections`,
                    label: 'Hub & Spoke',
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill="#007BFF" d="M10.707 7.293a1 1 0 0 0-1.414 0L5 11.586V10a1 1 0 1 0-2 0v4a1 1 0 0 0 1 1h4a1 1 0 1 0 0-2H6.414l4.293-4.293a1 1 0 0 0 0-1.414zM18 3h-4a1 1 0 1 0 0 2h1.586l-4.293 4.293a1 1 0 0 0 1.414 1.414L17 6.414V8a1 1 0 1 0 2 0V4a1 1 0 0 0-1-1zm2 14h-4a1 1 0 1 0 0 2h1.586l-4.293 4.293a1 1 0 0 0 1.414 1.414L17 19.414V21a1 1 0 1 0 2 0v-4a1 1 0 0 0-1-1z" />
                        </svg>

                    ),
                    path: '/management/route-management/routes',
                    isEnabled: true,

                },


            ],
        }
    ]

}
)
